import React, { Component } from 'react';
//import Config from './Config';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/Login.css';
import FX from './functions/functions';
class Login extends Component {
  
  constructor(props) {
    super(props);
    this.state = {};
    this.props.root.autoKey = this.autoKey;
  }
  autoKey = (e) => {
    if(e.key === 'Enter'){
        console.log(e.target.id.split("_")[0]);
        console.log(this.enterAction);
        if(typeof this.enterAction[e.target.id.split("_")[0]] === 'function'){
           this.enterAction[e.target.id.split("_")[0]](e);
        }
    }
    console.log('xxx');
    console.log(e);
    console.log(e.key);
  }
  
  enterAction = {
    'passer': (e)=> {
      console.log(e.key);
      this.login();
    }
  }
  wipeWarn = () => {
      this.setState({failwarn: false});
  }
  login = () => {
    console.log(document.querySelectorAll('input'));
    var d = document.querySelectorAll('input');
      FX.load(this.props.root, 'loginData', (ex)=> {
        console.log(ex.authenticated);
        console.log(ex);
        if(ex.authenticated){
            localStorage.token = ex.authenticated;
            this.props.root.setState(ex)
        }
        else{
            localStorage.token = '';
            this.props.root.setState(ex)
            this.setState({failwarn: true});
        }
    }, {method:'POST',data:{un:d[0].value,pw:d[1].value}});
    this.props.root.setState({panel:'dashboard',data_loaded:true});
  }
  render() {
    var failwarn;
    if(this.state.failwarn){
      failwarn = (<div className="failwarn">
                    <div className="message">
                      <p>Sorry, something wasn't quite right.</p>
                      <p>Please check your username and password and try again.</p>
                      <button onClick={this.wipeWarn}>Retry</button>
                    </div>
                  </div>)
    }
    return (
      <div className="Login" id="Login">
        {failwarn}
        <div className="ad_box">
          <img className="logo" src="/images/vdepot_logo_full.png" alt="Logo" title="Logo" />
          <div className="sub_sep"></div>
        </div>
        <div className="LoginBox">
          <div className="LoginCard">
            <div className="title">Login</div>
            <div>
              <div id="u"><input placeholder="Username" /></div>
              <div id="p"><input placeholder="Password"  type="password" id="passer" /></div>
            </div>
            <button onClick={this.login}>Log in &raquo;</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js